import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";

import {
    ClienteModal,
    obterDadosCadastrais
} from "./functions";

import { Button } from "../../Button";
import { LoadingButton } from "../../loadingButtom";
import { ErroTabela } from "../../Erros/ErroTabela";

import { DateFormatter } from "../../../functions/DateFormatter";

import "./styles.css";


interface ModalProps {
    modal: boolean;
    setModal: (modal: boolean) => void;
    idCliente?: string;
}


interface InfoRowProps {
    label: string;
    value?: React.ReactNode;
}


const InfoRow = ({
    label,
    value
}: InfoRowProps) => (
    <div className="info-row">
        <span className="info-label">
            {label}
        </span>

        <span className="info-value">
            {value !== undefined &&
                value !== null &&
                value !== ""
                ? value
                : "-"
            }
        </span>
    </div>
);


export const ModalDadosPessoaisCliente = ({
    modal,
    setModal,
    idCliente
}: ModalProps) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [erro, setErro] = useState<boolean>(false);
    const [desconectar, setDesconectar] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);

    const [usuario, setUsuario] = useState<ClienteModal | undefined>(
        undefined
    );


    useEffect(() => {
        if (!modal || !idCliente) {
            return;
        }

        setUsuario(undefined);

        obterDadosCadastrais(
            idCliente,
            setUsuario,
            setLoading,
            setErro,
            setDesconectar
        );

    }, [
        modal,
        idCliente,
        reload
    ]);


    const renderPessoaFisica = () => {
        return (
            <>
                <div className="section-title">
                    Informações Pessoais
                </div>

                <div className="info-grid">
                    <InfoRow
                        label="Nome"
                        value={usuario?.nome}
                    />

                    <InfoRow
                        label="CPF"
                        value={usuario?.cpf}
                    />

                    <InfoRow
                        label="RG"
                        value={usuario?.rg}
                    />

                    <InfoRow
                        label="Órgão Expeditor"
                        value={usuario?.orgaoExpeditor}
                    />

                    <InfoRow
                        label="UF Expeditor"
                        value={usuario?.ufOrgaoExpeditor}
                    />

                    <InfoRow
                        label="Nacionalidade"
                        value={usuario?.nacionalidade}
                    />

                    <InfoRow
                        label="Nascimento"
                        value={
                            usuario?.dataNascimento
                                ? DateFormatter(
                                    usuario.dataNascimento
                                )
                                : "-"
                        }
                    />

                    <InfoRow
                        label="Renda"
                        value={usuario?.renda}
                    />

                    {/* <InfoRow
                        label="Telefone"
                        value={usuario?.telefone}
                    /> */}
                </div>
            </>
        );
    };


    const renderPessoaJuridica = () => {
        return (
            <>
                <div className="section-title">
                    Informações da Empresa
                </div>

                <div className="info-grid">
                    <InfoRow
                        label="Nome Fantasia"
                        value={usuario?.nome}
                    />

                    <InfoRow
                        label="Razão Social"
                        value={usuario?.razaoSocial}
                    />

                    <InfoRow
                        label="CNPJ"
                        value={usuario?.cnpj}
                    />

                    {/* <InfoRow
                        label="Telefone"
                        value={usuario?.telefone}
                    /> */}
                </div>
            </>
        );
    };


    const renderEndereco = () => {
        return (
            <>
                <div className="section-title">
                    Endereço
                </div>

                <div className="info-grid">
                    <InfoRow
                        label="Rua"
                        value={usuario?.rua}
                    />

                    <InfoRow
                        label="Complemento"
                        value={usuario?.complemento}
                    />

                    <InfoRow
                        label="Bairro"
                        value={usuario?.bairro}
                    />

                    <InfoRow
                        label="Cidade"
                        value={usuario?.cidade}
                    />

                    <InfoRow
                        label="Estado"
                        value={usuario?.estado}
                    />

                    <InfoRow
                        label="CEP"
                        value={usuario?.cep}
                    />
                </div>
            </>
        );
    };


    return (
        <Modal
            show={modal}
            onHide={() => setModal(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Dados do Cliente
                </Modal.Title>
            </Modal.Header>

            {erro ? (
                <ErroTabela
                    handleClick={() =>
                        setReload(valorAtual => !valorAtual)
                    }
                    className="formatacaoGrafico"
                />
            ) : loading ? (
                <div className="caixa1">
                    <LoadingButton />
                </div>
            ) : (
                <Modal.Body>
                    {usuario && (
                        <>
                            {usuario.tipoCliente === "PJ"
                                ? renderPessoaJuridica()
                                : renderPessoaFisica()
                            }

                            {renderEndereco()}
                        </>
                    )}
                </Modal.Body>
            )}

            <Modal.Footer>
                <Button
                    classNameButton="btnCancelar"
                    onClick={() => setModal(false)}
                    titleButton="Fechar"
                />
            </Modal.Footer>
        </Modal>
    );
};